import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'eco_friendly-definition_banner_show_more_button-click';

/**
 * User clicks the "Show more" button at Eco-friendly definition banner at Eco-friendly c1/c2 page.
 */
export function trackEcoFriendlyDefinitionBannerShowMoreButtonClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
  });
}
